export enum EntityType {
  Club = 'club',
  Profile = 'profile',
  Player = 'profile', // alias for legacy support
  Competition = 'competition',
  CompetitionSeason = 'competition-season',
  Team = 'team',
  TeamSeason = 'team-season',
  Match = 'match',
  User = 'user',
  News = 'news',
  Gallery = 'gallery',
  Transfer = 'transfer',
  PlayerSeason = 'player-season',
  ProfileFunction = 'profile-function',
  Region = 'region',
  District = 'district',
  ElevenOfTheWeek = 'eleven-of-the-week',
  Video = 'video',
  Referee = 'referee',
  Season = 'season',
  PlayerPosition = 'player-position',
  PowerRanking = 'power-ranking',
  FupaTv = 'fupa-tv',
  Cobranding = 'cobranding',
  MatchPlayer = 'match-player',
  Syndicate = 'syndicate',
  CompetitionSeasonTopScorers = 'competition-season-top-scorers',
  MatchFact = 'match-fact',
}
